'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dUser$002dEntry from "./presto.types$-User-Entry.js";
var $p;
/** @constructor */
function $c_Lpresto_types$UserEntry$() {
}
export { $c_Lpresto_types$UserEntry$ as $c_Lpresto_types$UserEntry$ };
$p = $c_Lpresto_types$UserEntry$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$UserEntry$;
/** @constructor */
function $h_Lpresto_types$UserEntry$() {
}
export { $h_Lpresto_types$UserEntry$ as $h_Lpresto_types$UserEntry$ };
$h_Lpresto_types$UserEntry$.prototype = $p;
$p.l = (function() {
  return "UserEntry";
});
$p.qZ = (function(x$0) {
  return new $j_presto$002etypes$0024$002dUser$002dEntry.$c_Lpresto_types$UserEntry($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), x$0.j(1), x$0.j(2), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(3)), x$0.j(4), x$0.j(5), (!(!x$0.j(6))), x$0.j(7));
});
var $d_Lpresto_types$UserEntry$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$UserEntry$, "presto.types$UserEntry$", ({
  a2D: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$UserEntry$ as $d_Lpresto_types$UserEntry$ };
var $n_Lpresto_types$UserEntry$;
function $m_Lpresto_types$UserEntry$() {
  if ((!$n_Lpresto_types$UserEntry$)) {
    $n_Lpresto_types$UserEntry$ = new $c_Lpresto_types$UserEntry$();
  }
  return $n_Lpresto_types$UserEntry$;
}
export { $m_Lpresto_types$UserEntry$ as $m_Lpresto_types$UserEntry$ };
//# sourceMappingURL=presto.types$-User-Entry$.js.map
